/* CrossFit Games — shared behaviour for the split cfg-* sections.
   The product/bundle buttons use the store's real cart (plain /cart/add
   forms + a cart permalink), so this only handles the gallery carousel,
   FAQ accordion, and the copy-code button. Guarded to run once. */
(function(){
  if (window.__cfgGamesInit) return;
  window.__cfgGamesInit = true;

  // Rebuild the "Add Games Stack" cart permalink from each product's currently
  // chosen variant (flavour), so the bundle adds the selected flavours.
  function cfgRebuildBundle(root){
    var a = root.querySelector('[data-cfg-bundle]');
    if (!a) return;
    var ids = [].slice.call(root.querySelectorAll('.cfg-product[data-cfg-variant]'))
      .map(function(p){ return p.getAttribute('data-cfg-variant'); })
      .filter(Boolean);
    if (!ids.length) return;
    var href = '/cart/' + ids.map(function(id){ return id + ':1'; }).join(',');
    var code = a.getAttribute('data-cfg-code');
    if (code) href += '?discount=' + encodeURIComponent(code);
    a.setAttribute('href', href);
  }

  // Apply a chosen variant to a product and keep every picker (card + bundle),
  // the add form, the card price and the bundle permalink in sync.
  function cfgApplyVariant(product, variantId, priceText){
    if (!product || !variantId) return;
    product.setAttribute('data-cfg-variant', variantId);
    var input = product.querySelector('.cfg-add-form [name="id"]');
    if (input) input.value = variantId;
    if (priceText){ var pe = product.querySelector('.cfg-pprice'); if (pe) pe.textContent = priceText; }
    var block = product.getAttribute('data-cfg-block');
    var pickers = [product.querySelector('[data-cfg-flavour]')];
    if (block) pickers.push(document.querySelector('[data-cfg-bundle-flavour][data-cfg-target="' + block + '"]'));
    pickers.forEach(function(s){ if (s && s.value !== variantId) s.value = variantId; });
    var root = product.closest('.cfg');
    if (root) cfgRebuildBundle(root);
  }

  // Flavour dropdowns — on the product card and in the bundle, both drive the same variant.
  document.addEventListener('change', function(e){
    var card = e.target.closest('[data-cfg-flavour]');
    if (card){
      var co = card.options[card.selectedIndex];
      cfgApplyVariant(card.closest('.cfg-product'), card.value, co && co.getAttribute('data-price'));
      return;
    }
    var bsel = e.target.closest('[data-cfg-bundle-flavour]');
    if (bsel){
      var target = bsel.getAttribute('data-cfg-target');
      var bproduct = target ? document.querySelector('.cfg-product[data-cfg-block="' + target + '"]') : null;
      var bo = bsel.options[bsel.selectedIndex];
      cfgApplyVariant(bproduct, bsel.value, bo && bo.getAttribute('data-price'));
      return;
    }
  });

  [].slice.call(document.querySelectorAll('.cfg')).forEach(cfgRebuildBundle);

  // Real add-to-cart for the stack products. We handle it ourselves (capture
  // phase) rather than let the theme's legacy-form handler run, because that
  // one fires a `cart:change` built from /cart.js (no `.sections`), which the
  // theme's own capture-phase guard drops — so the item adds but the drawer
  // never refreshes. `cart:refresh` is not guarded and forces a full reload.
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('cfg-add-form')) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('disabled', '');

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(r){
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function(){
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var drawer = document.getElementById('cart-drawer');
      if (drawer){ if (typeof drawer.show === 'function') drawer.show(); else drawer.setAttribute('open', ''); }
      if (btn) btn.removeAttribute('disabled');
    }).catch(function(){
      // Fallback: let the browser do a normal form POST (adds + lands on /cart).
      if (btn) btn.removeAttribute('disabled');
      form.submit();
    });
  }, true);

  document.addEventListener('click', function(e){
    // Bundle: add the chosen flavours to the real cart + open the drawer (no page jump)
    var bundleBtn = e.target.closest('[data-cfg-bundle]');
    if (bundleBtn){
      e.preventDefault();
      var broot = bundleBtn.closest('.cfg');
      var ids = broot ? [].slice.call(broot.querySelectorAll('.cfg-product[data-cfg-variant]'))
        .map(function(p){ return p.getAttribute('data-cfg-variant'); }).filter(Boolean) : [];
      if (!ids.length){ window.location.href = bundleBtn.getAttribute('href'); return; }
      var code = bundleBtn.getAttribute('data-cfg-code');
      bundleBtn.style.pointerEvents = 'none';
      var openDrawer = function(){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.getElementById('cart-drawer');
        if (drawer){ if (typeof drawer.show === 'function') drawer.show(); else drawer.setAttribute('open', ''); }
      };
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map(function(id){ return { id: id, quantity: 1 }; }) })
      }).then(function(r){
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function(){
        openDrawer();                       // open the slide cart straight away
        bundleBtn.style.pointerEvents = '';
        // apply the bundle code in the background so it's live at checkout, then refresh the drawer
        if (code) fetch('/discount/' + encodeURIComponent(code), { mode: 'no-cors' })
          .then(function(){ setTimeout(openDrawer, 250); }).catch(function(){});
      }).catch(function(){
        bundleBtn.style.pointerEvents = '';
        window.location.href = bundleBtn.getAttribute('href');
      });
      return;
    }

    // Gallery arrows
    var gal = e.target.closest('[data-cfg-gal]');
    if (gal){
      var wrap = gal.closest('.cfg');
      var track = wrap && wrap.querySelector('[data-cfg-gal-track]');
      var slide = track && track.querySelector('.cfg-gal-slide');
      var step = slide ? slide.getBoundingClientRect().width + 20 : 300;
      if (track) track.scrollBy({ left: parseInt(gal.getAttribute('data-cfg-gal'), 10) * step, behavior: 'smooth' });
      return;
    }

    // FAQ accordion
    var faq = e.target.closest('[data-cfg-faq]');
    if (faq){
      var item = faq.parentElement, panel = faq.nextElementSibling;
      var isOpen = item.classList.toggle('cfg-open');
      panel.style.maxHeight = isOpen ? (panel.scrollHeight + 'px') : '0px';
      return;
    }

    // Copy bundle code
    var copy = e.target.closest('[data-cfg-copy]');
    if (copy){
      var code = copy.getAttribute('data-cfg-copy') || '';
      var done = function(){
        copy.textContent = 'Copied';
        copy.classList.add('cfg-copied');
        setTimeout(function(){ copy.textContent = 'Copy'; copy.classList.remove('cfg-copied'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(done).catch(done); }
      else { done(); }
    }
  });
})();
